import React from 'react';
import cn from 'classnames';
import { CartItemType } from '@base/cart/interface';
import styles from './cartMenu.module.less';
import CartItemImage from '@base/cart/CartItemImage';
import CartItemName from '@base/cart/CartItemName';
import CartItemAttrs from '@base/cart/CartItemAttrs';
import CartItemPrice from '@pro/cart/CartItemPrice';
import CartItemQty from '@base/cart/CartItemQty';
import { CartType } from '@base/cart/useCart';
import { isBonusProduct } from 'base/utils/product';
import CartItemCheckbox from '@base/cart/CartItemCheckbox';
import { ICartGroup } from 'mod/cart/interface';
import Iconfont from '@base/lib/Iconfont';
import { CartItemMinOrders } from '@pro/cart/CartItemMinOrders';
import { CartItemAvgPrice } from '@pro/cart/CartItemAvgPrice';
import CartItemWholesaleTip from '@base/cart/CartItemWholesaleTip';

declare interface IProps {
    item: CartItemType;
    index: number;
    onChangeItemNum: (itemId: string, num: number) => void;
    onDeleteItem: (itemId: string, isOos: boolean) => void;
    isBatchList: boolean;
    loadCart: CartType['loadCart'];
    group: ICartGroup;
}

const CartItem: React.FC<IProps> = (props) => {
    const {
        item,
        index,
        onChangeItemNum,
        onDeleteItem,
        isBatchList,
        loadCart,
        group,
    } = props

    const isOos = item.stockNum === 0;
    const isBonus = isBonusProduct(item);

    return (
        <div className={cn(
            'flex',
            styles.item,
            { [styles['item-oos']]: item.stockNum === 0 }
        )}>
            <div
                className={styles['col-checkbox']}
                style={{ visibility: isBonus||group.forceBatchOperate ? 'hidden' : 'visible' }}
            >
                <CartItemCheckbox
                    className={styles['checkbox-common']}
                    item={item}
                    batchActive={false}
                />
            </div>
            <div className={styles['col-picture']}>
                <CartItemImage
                    item={item}
                    width={120}
                    group={group}
                />
            </div>

            <div className="flex-1">
                <div className={cn(styles.info, 'flex flex-vertical')}>
                    <div className="flex-1">
                        <CartItemName className={styles.name} item={item}/>
                        <CartItemAttrs className={styles.attrs} item={item}/>
                        <CartItemMinOrders className={styles['min-qty']} item={item}/>
                        <CartItemAvgPrice className={styles['avg-price']} item={item}/>
                    </div>
                    <div className="flex flex-top flex-justify">
                        <CartItemPrice className={styles.price} item={item}/>
                        <div className={cn(styles['item-options'], 'relative')}>
                            <CartItemQty
                                className={styles.qty}
                                item={item}
                                onChangeItemNum={onChangeItemNum}
                                changeable={!group.forceBatchOperate}
                            />
                            <button
                                type="button"
                                className={cn('btn-no-style', styles['btn-delete'])}
                                onClick={() => onDeleteItem(item.id, isOos)}
                                disabled={item.isChangingQty}
                            >
                                <Iconfont className={'icon-ashbin'}/>
                            </button>
                        </div>
                    </div>

                    <CartItemWholesaleTip item={item} className={styles['item-fail-tip']}/>

                </div>
            </div>
        </div>
    )
}

export default React.memo(CartItem);
